var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 235.11 226.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-6 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-7 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        stroke-width: 1.99px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        opacity: 0;\n        stroke: #000;\n        stroke-miterlimit: 1;\n      }\n\n      .cls-3 {\n        stroke-width: .8px;\n      }\n\n      .cls-4 {\n        stroke-width: .79px;\n      }\n\n      .cls-8 {\n        fill: #22b573;\n      }\n\n      .cls-9 {\n        mix-blend-mode: overlay;\n        opacity: .49;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-11 {\n        fill: #0e2e4d;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-13 {\n        fill: #f9f9f9;\n        fill-rule: evenodd;\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.46,43.95c-35.02,39.39-31.59,99.85,7.67,135.03,39.27,35.17,99.49,31.75,134.52-7.64,35.02-39.4,31.59-99.86-7.67-135.03-18.17-16.28-40.85-24.3-63.43-24.3-26.19,0-52.27,10.78-71.09,31.93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1810.47,
    y1: -4732.54,
    x2: -1810.47,
    y2: -4923.8,
    gradientTransform: "translate(-1692.91 -4720.51) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99dfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#77b2e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9cace7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1a7e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.62,39.46c-6.43,3.98-12.4,8.96-17.69,14.9-5.29,5.95-9.53,12.48-12.74,19.35l4.33,76.21c3.97,6.46,8.92,12.46,14.85,17.78,5.93,5.32,12.42,9.58,19.26,12.8l75.88-4.3c6.43-3.98,12.4-8.96,17.68-14.9,5.29-5.95,9.53-12.48,12.74-19.34l-4.33-76.22c-3.97-6.46-8.92-12.46-14.84-17.77-5.93-5.31-12.42-9.58-19.26-12.8l-75.87,4.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.24,
    y: 37.19,
    width: 140.64,
    height: 141.27,
    transform: "translate(-5.92 6.84) rotate(-3.25)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 15.04
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.44
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "newer"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 97.59,
    cy: 136.57,
    r: 75.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 5.88,
    y: 6.16,
    width: 223.35,
    height: 213.85,
    transform: "translate(-6.22 6.85) rotate(-3.25)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.46,43.95c-35.03,39.39-31.59,99.85,7.67,135.03,39.27,35.17,99.49,31.75,134.52-7.64,35.02-39.4,31.59-99.86-7.67-135.03C141.72,1.14,81.5,4.56,46.46,43.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M49.38,46.9c-33.6,37.79-30.3,95.77,7.35,129.51,37.66,33.74,95.4,30.46,129-7.32,33.58-37.79,30.29-95.77-7.36-129.51C140.73,5.83,82.98,9.11,49.38,46.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.38,46.9c-33.6,37.79-30.3,95.77,7.35,129.51,37.66,33.74,95.4,30.46,129-7.32,33.58-37.79,30.29-95.77-7.36-129.51C140.73,5.83,82.98,9.11,49.38,46.9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("image", {
    width: 150,
    height: 150,
    transform: "translate(43.34 41.29) rotate(-3.25) scale(.94)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAACXBIWXMAAAsSAAALEgHS3X78AAAAbklEQVR4nO3BMQEAAADCoPVPbQsvoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgZYDUAAaMExRQAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.93,54.36c-29.38,33.07-26.5,83.81,6.43,113.34,32.94,29.52,83.44,26.66,112.83-6.41,29.37-33.07,26.49-83.81-6.43-113.34-32.94-29.52-83.44-26.66-112.83,6.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 38.06,
    y: 30.85,
    width: 159,
    height: 159,
    rx: 79.5,
    ry: 79.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M186,120.45c-4.09.64-10.19-.04-15.73-.52-5.16-.45-10.45-3.55-13.64-3.67l.06-1.08c.15,0,.3.01.46.03,5.38.45,11.15,3.08,17.31,3.67,4.01.38,8.02-.33,11.54,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M171.31,90.04c3.94-2.7,11.35-1.94,16.78-3.15-6.79,9.81-18.58,14.64-23.07,26.75-.47-.41-1.19-.57-2.1-.52,1.95-10.13,13.31-15.35,18.88-23.6-3.31.2-8.49,2.3-10.49.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165.54,90.04c.85-.15.9.5,1.57.52-.79,4.26-4.15,7.42-6.29,11.01-1.8,3.03-3.08,8.61-7.87,8.92,2.84-8.17,8.76-13.27,12.59-20.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M156.69,115.18l-.06,1.08c-8.54-.33-12.64,7.51-20.98,6.82.4-5.19,4.13-7.05,5.77-11.01-5.3,1.28-8.96,11.17-15.21,11.54,2.35-4.99,6.22-8.46,8.39-13.64-8.2-.34-8.29,11.98-16.26,13.64-2.11-.16-3.29-1.25-4.2-2.62-3.1.74-4.42,3.28-8.39,3.15-2.7-2.81.51-6.61,2.1-8.39-1,.42-2,1.05-2.99,1.81l-1.07-1.14c3.97-3.18,8.57-7.38,12.98-8.02-1.82,5.52-7.93,6.75-9.44,12.59,8.9.49,11.48-9.83,17.83-13.64,2.19-.45,2.08,1.42,3.15,2.1,3.95-.41,5.86-2.87,9.44-3.67,2.78,2.78-1.28,5.44-2.1,7.87,3.07-1.82,5.66-6.34,9.44-5.77,1.22,5.3-4.43,8.11-5.77,12.59,5.54-1.14,10.1-5.68,17.37-5.27ZM117.82,120.98c4.93-1.01,6.19-5.7,7.87-9.96-3.64.27-7.37,4.82-7.87,9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.06,94.23c1.19,1.57-.76,3.51-3.15,3.15.19-1.91,1.24-2.96,3.15-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M90.02,119.4c5.95-.71,9.56-11.04,16.26-11.01-.66,3.25-5.84,6.35-6.82,11.01,1.31-.66,2.77-1.75,4.33-2.99l1.07,1.14c-2.54,1.95-5.05,4.82-7.49,7.63-3.04,3.48-5.24,11.01-10.49,8.39,3.59-5.15,8.26-9.22,10.49-15.73-1.25-.09-7.83,8.06-9.96,2.1-3.53,1.24-10.37,6.59-13.64,1.57-.03-4.75,4.96-4.48,7.87-6.29-.63-.53-1.77-.57-2.93-.58l.03-1.51c3.79,0,7.57-2.24,11.29-.53-.17.26-.36.49-.56.72-3.06,3.33-9.75,3.03-12.03,7.15,6.06,1.55,9.68-2.56,13.39-6.68,3.38-3.74,6.84-7.49,12.31-6.96-4.79,3.78-10.77,6.37-13.11,12.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.32,88.99c-.8-.04-1.6-.06-2.41-.06l.02-1.21c1.67,0,3.34.07,5.01.22-1.76,6.83-9.95,8.04-16.26,9.96-1.32.4-2.63.85-3.93,1.35l-.41-1.1c6.58-2.47,12.82-5.27,17.98-9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M93.93,87.72l-.02,1.21c-12.15,0-25.28,4.27-35.88,8.97-3.42,1.52-7.25,5.36-11.01,3.15,12.92-6.26,29.51-13.41,46.91-13.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M90.02,104.72c-.61,3.99-9.07,4.52-11.54,8.39.08,0,.17,0,.25,0l-.03,1.51c-1.79-.02-3.64.04-3.89-1.52,3.45-4.42,8.94-6.8,15.21-8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M78.34,98.15l.41,1.1c-5.22,1.95-10.27,4.41-14.95,5.99.66,5.33,2.99,9.63,5.24,13.64,2.31,4.11,5.76,7.21,6.82,11.01-3.91-.12-7.42-4.71-9.44-8.39-2.2-4.01-3.14-9.46-4.72-13.64-5.61,2.95-1.94,15.19-9.96,15.73.41-3.73,3.3-8.4,5.24-13.11,1.75-4.24,2.77-10.58,6.82-11.01,2.79.76-1.33,2.57-1.05,4.2,5.16-1.88,10.47-3.6,15.59-5.52Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR17);
export default __webpack_public_path__ + "static/media/R17.614abe32f4036492a911ae50ff7caa4e.svg";
export { ForwardRef as ReactComponent };